import { useState, useEffect } from "react"

export default function useFetchQuestions(scriptUrl, quizId, fallback = []) {
    const [questions, setQuestions] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        if (!scriptUrl) {
            setQuestions(fallback)
            setLoading(false)
            return
        }
        const url = `${scriptUrl}?quizId=${encodeURIComponent(quizId)}`
        fetch(url)
            .then(r => r.json())
            .then(data => { setQuestions(data.length ? data : fallback); setLoading(false) })
            .catch(() => {
                setQuestions(fallback.length ? fallback : [])
                setError(fallback.length ? null : "Failed to load questions.")
                setLoading(false)
            })
    }, [scriptUrl, quizId])

    return { questions, loading, error }
}
